import { Modal } from "antd";
import DebtDetailContent from "./DebtDetailContent";

/**
 * DebtModal - Modal wrapper for DebtDetailContent
 *
 * @param {Object} props
 * @param {boolean} props.open - Whether the modal is open
 * @param {function} props.onClose - Callback to close the modal
 * @param {string} props.userId - User ID
 * @param {string} props.type - Type (USER_SELLER, USER_GUIDE, USER_COORDINATOR, etc.)
 * @param {string} props.extraInfo - Extra info for the debt query
 * @param {string} props.transferId - Optional transfer ID for editing existing transfers
 * @param {function} props.onSuccess - Optional callback when transfer is completed successfully
 */
function DebtModal({ open, onClose, userId, type, extraInfo, transferId, onSuccess }) {
  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="95vw"
      title="Rendir Deuda"
      styles={{ body: { height: "85vh", overflowY: "auto", overflowX: "hidden" } }}
      destroyOnClose
      centered
    >
      {open && (
        <DebtDetailContent
          userId={userId}
          type={type}
          extraInfo={extraInfo}
          transferId={transferId}
          onSuccess={handleSuccess}
          onCancel={onClose}
          isModal={true}
        />
      )}
    </Modal>
  );
}

export default DebtModal;
